export default "__VITE_ASSET__DDe3tk85__"